import { renderSlot as _renderSlot, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-084c8b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputWithIcon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "icon", {}, undefined, true),
    _withDirectives(_createElementVNode("input", _mergeProps({ type: "text" }, _ctx.$attrs, {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_ctx.localValue)))
    }), null, 16), [
      [_vModelText, _ctx.localValue]
    ])
  ]))
}